import { SaveSharedTabButton } from '@/App/tabs/saveSharedTabButton.tsx';
import { SaveWorkspaceButton } from '@/App/tabs/SaveWorkspaceButton.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectIsActiveTabShared } from '@/store/tabs/selectors.ts';

export function SaveButton() {
  const isActiveTabShared = useAppSelector(selectIsActiveTabShared);

  if (isActiveTabShared) {
    return <SaveSharedTabButton />;
  }

  return <SaveWorkspaceButton />;
}
